<template>
  <div v-for="(item,index) in userRemarkList" :key="index" style="margin: 8px 0; font-size: 14px; display: flex; flex-wrap: wrap;">
    <span style="margin-right: 8px;">{{item.createTime}}</span>
    <el-tag size="small" style="margin-right: 8px; ">{{item.adminName}}</el-tag>
<!--    <span style="margin-right: 8px;" v-high-light="{value: item.content}">{{item.content}}</span>-->
    <span style="margin-right: 8px;">{{item.type == 1?'审核不通过：':item.type == 2?'审核通过：':''}}{{item.content}}</span>
  </div>
</template>

<script>
export default {
name: "UserLog",
  props: {
    userRemarkList: {
      type: Array,
      default: [],
    }
  }
}
</script>

<style scoped>

</style>
